import { render, staticRenderFns } from "./NotificationsSettingsItem.vue?vue&type=template&id=44fc7b14&scoped=true&"
import script from "./NotificationsSettingsItem.vue?vue&type=script&lang=js&"
export * from "./NotificationsSettingsItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSettingsItem.vue?vue&type=style&index=0&id=44fc7b14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc7b14",
  null
  
)

export default component.exports